export default __webpack_public_path__ + "static/media/pcsb.54c3bcc4.png";